/* eslint-disable @typescript-eslint/naming-convention */

import {ClientDesktopOnly} from 'components/ClientDesktopOnly';
import {FaqCard} from 'modules/events/components/FaqCard';
import {NextButton} from 'modules/events/components/Faq/NextButton';
import {PrevButton} from 'modules/events/components/Faq/PrevButton';
import {FAQ_LIST} from 'modules/events/constants';
import {FC, useState} from 'react';
import {Pagination} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/react';
import {SwiperClass} from 'swiper/swiper-react';
import {SwiperOptions} from 'swiper/types';
import 'swiper/css';
import 'swiper/css/pagination';
import style from './style.module.scss';

const BREAKPOINTS = {
    0: {
        slidesPerView: 'auto',
        spaceBetween: 12,
    } as SwiperOptions,
    768: {
        slidesPerView: 'auto',
        spaceBetween: 20,
    } as SwiperOptions,
    1024: {
        slidesPerView: 3,
        spaceBetween: 32,
    } as SwiperOptions,
};

const SWIPER_MODULES = [Pagination];
const SWIPER_PAGINATION = {
    clickable: true,
};

export const FaqSlider: FC = () => {
    const [swiper, setSwiper] = useState<SwiperClass>();

    return (
        <div className={style.main}>
            <Swiper
                breakpoints={BREAKPOINTS}
                className={style.swiper}
                modules={SWIPER_MODULES}
                onSwiper={setSwiper}
                pagination={SWIPER_PAGINATION}
            >
                {FAQ_LIST.map(({description, title}) => {
                    return (
                        <SwiperSlide className={style.slide} key={title}>
                            <div className={style.cardContainer}>
                                <FaqCard description={description} title={title} />
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
            <ClientDesktopOnly>
                <PrevButton swiper={swiper} />
                <NextButton swiper={swiper} />
            </ClientDesktopOnly>
        </div>
    );
};
